import type { Project } from '../types';
import { parseJSON } from '../components/ProjectForm';

export function projectIsStrategic(p: Project): boolean {
  return !!parseJSON<any>(p.rcajo, {}).is_strategic;
}

// Current RCAJO "note" for a project: the average current_score (0–5 maturity
// scale, same as the Préqualification resource table) across every resource
// the project touches — both capability-linked and standalone. Null when the
// project isn't strategic or none of its resources have a baseline score yet.
export function projectRcajoScore(p: Project): number | null {
  const rcajo = parseJSON<any>(p.rcajo, {});
  if (!rcajo.is_strategic) return null;
  const capResources = Array.isArray(rcajo.capabilities)
    ? rcajo.capabilities.flatMap((c: any) => Array.isArray(c.resources) ? c.resources : [])
    : [];
  const standalone = Array.isArray(rcajo.resources) ? rcajo.resources : [];
  const scores = [...capResources, ...standalone]
    .map((r: any) => r?.current_score)
    .filter((n: any): n is number => typeof n === 'number' && !Number.isNaN(n));
  if (scores.length === 0) return null;
  return Math.round((scores.reduce((a: number, b: number) => a + b, 0) / scores.length) * 10) / 10;
}
